module.exports = __webpack_public_path__ + "static/media/box-logo.c5217e90.png";